import React from "react";
import { FORM_WIZARD_STEPS } from "./borrowerUploadConfig.js";

export default function FormStepProgress({ currentStep = 0, stepErrors = {}, steps = FORM_WIZARD_STEPS }) {
  const total = steps.length;
  const stepIndex = Math.max(0, Math.min(currentStep, total - 1));
  const label = steps[stepIndex]?.label || "";

  return (
    <div className="mb-4 min-w-0" aria-label={`Application form progress, step ${stepIndex + 1} of ${total}`}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-xs font-semibold text-slate-600">
          Step {stepIndex + 1} of {total}
        </p>
        <p className="text-xs font-medium text-sky-700 truncate">{label}</p>
      </div>
      <div className="flex gap-1" role="tablist" aria-label="Form steps">
        {steps.map((step, idx) => {
          const isDone = idx < stepIndex;
          const isCurrent = idx === stepIndex;
          const hasError = Boolean(stepErrors[step.id]);
          return (
            <div
              key={step.id}
              role="tab"
              aria-selected={isCurrent}
              aria-label={`${step.label}${hasError ? ", has errors" : ""}`}
              className={[
                "h-1.5 flex-1 rounded-full transition-colors",
                hasError ? "bg-rose-400" : isDone || isCurrent ? "bg-sky-400" : "bg-slate-200",
              ].join(" ")}
            />
          );
        })}
      </div>
    </div>
  );
}
